import { render, staticRenderFns } from "./CheckDataView.vue?vue&type=template&id=6c530589"
import script from "./CheckDataView.vue?vue&type=script&lang=ts"
export * from "./CheckDataView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports